/**
 * @link https://github.com/RedTecLab/varnish-plus/blob/master/varnish-devicedetect/devicedetect.vcl
 */

export const DEVICE_CLASS_DESKTOP = 'pc'
export const DEVICE_CLASS_BOT = 'bot'
